import { render } from "./showQty.vue?vue&type=template&id=60ba5168&scoped=true"
import script from "./showQty.vue?vue&type=script&lang=js"
export * from "./showQty.vue?vue&type=script&lang=js"

import "./showQty.vue?vue&type=style&index=0&id=60ba5168&scoped=true&lang=css"

import exportComponent from "/home/forge/app-ticket.grandigiardini.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ba5168"]])

export default __exports__